<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>

    <v-row align="center" justify="center">
        <v-col  cols="8" class="pa-0">
            <v-text-field outlined height="43" hide-details v-model="typename" :label="$t('common_eventinfo_label4')" dense disabled></v-text-field>
        </v-col>
        <v-col cols="4" class="pa-0" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" width="800px">
        <v-card class="dialog_round pa-5">
          <v-card-title>
            <v-row justify="space-between">
              <v-col align="center" cols="12" md="6" sm="6" xs="6">
                <span class="dialog_title">{{$t('eventtypedialog_label1')}}</span>
              </v-col>
              <v-col align="center" cols="12" md="6" sm="6" xs="6">
                <v-btn class="dialog_btn mr-10" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    ref="table"
                    :headers="headers_com"
                    :items="itemList_com"
                    v-model="select_com"
                    :no-data-text="$t('common_nodata')"
                    hide-default-footer
                    
                    class="datatablestyle"
                    :items-per-page="9999"
                    item-key="IDX"
                    >
                    <template v-slot:header.TYPENAME>
                      <label class="cheader_normal" >{{$t("eventtypedialog_col1")}}</label>
                    </template>
                    <template v-slot:header.TYPEDESC>
                      <label class="cheader_normal" >{{$t("eventtypedialog_col2")}}</label>
                    </template>
                                                            
                    <template v-slot:item.TYPENAME="{ item }">
                      <a @click="select_func(item)">{{item.TYPENAME}}</a>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            typename: String,
        },

        data: ()=> ({
            dialog_com : false,
            load_flag : false,
            headers_com: [
              {text: '행사타입', value: 'TYPENAME', sortable: false, align:'center'},
              {text: '설명', value: 'TYPEDESC', sortable: false, align:'center'},
            ],

            itemList_com: [],
            select_com:[],
            
        }),

        updated(){
          
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0){
              this.load_flag = false;
              this.loadpage_com();
            }
          }else{
            this.load_flag = false;
          }

        },
        

        methods: {
            search_run_com(){
                this.loadpage_com();
            },

            loadpage_com(){

                
                this.$http.post(this.$host+'/api/StepTypeList',{
                    ADMIN_IDX: this.$session.get("ADMIN_IDX")
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                    this.load_flag = true;
                    if(result.data.resultCode == 0){

                        //토큰 저장
                        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                        }
                        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                        }

                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            //선택 초기화
            clear_com () {
                this.$emit('callback', {AREANAME:'', IDX:''})
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },
            
            //선택
            select_func(select_item){
              this.$emit('callback', select_item)
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            showpopup_com(){
                this.dialog_com = true;
                this.load_flag = false;
            },


        }

    }
</script>

<style scoped>


</style>